import { logEvent, setUserId, setUserProperties } from "firebase/analytics";
import { analytics } from "../configs";

const safeRun = (fn) => {
  try {
    fn();
  } catch (error) {
    window.console.warn("analytics:", error);
  }
};

export const trackEvent = (name, params) =>
  safeRun(() => logEvent(analytics, name, params));

export const identifyUser = (userId) =>
  safeRun(() => setUserId(analytics, userId));

export const setUserProps = (props) =>
  safeRun(() => setUserProperties(analytics, props));

export const trackException = (description, { fatal = false, ...extra } = {}) =>
  safeRun(() =>
    logEvent(analytics, "exception", {
      description: String(description || "").slice(0, 200),
      fatal,
      ...extra,
    }),
  );

export const trackPixelEvent = (name, params) =>
  safeRun(() => window.fbq && window.fbq("track", name, params));

export const trackPixelCustomEvent = (name, params) =>
  safeRun(() => window.fbq && window.fbq("trackCustom", name, params));
